export default "__VITE_ASSET__lkNjlPm6__"